export default {
  mounted(el, binding) {
    if (!binding.value) return;
    const appendTo = binding.value instanceof HTMLElement
      ? binding.value : binding.value?.$el;
    (appendTo || document.body).appendChild(el);
  },
  unmounted(el, binding) {
    if (!binding.value) return;
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  },
};
